import { render, staticRenderFns } from "./teacherVidos.vue?vue&type=template&id=0a2db589"
import script from "./teacherVidos.vue?vue&type=script&lang=js"
export * from "./teacherVidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports